import {BrowserRouter,Routes, Route} from 'react-router-dom';
import Authentication from './authentication';
import Dashboard from './dashboard';
function App() {
  return (
      <BrowserRouter>
            <Routes>
            <Route exact path="/" element={<Authentication/>} />
            <Route exact path="/dashboard" element={<Dashboard/>} />
            </Routes>
      </BrowserRouter>
  );
}

export default App;
